import { useCallback } from 'react';
import PropTypes from 'prop-types';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
} from '@mui/material';

/**
 * Dialog component for confirming prompt deletion
 */
const PromptDeleteDialog = ({ open, prompt, onClose, onConfirm }) => {
	const handleConfirm = useCallback(() => {
		if (prompt) {
			onConfirm(prompt);
		}
		onClose();
	}, [prompt, onConfirm, onClose]);

	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby='delete-prompt-dialog-title'
			aria-describedby='delete-prompt-dialog-description'
			maxWidth='sm'
			fullWidth
		>
			<DialogTitle id='delete-prompt-dialog-title'>Confirm Delete</DialogTitle>
			<DialogContent>
				<DialogContentText id='delete-prompt-dialog-description'>
					Are you sure you want to delete &ldquo;{prompt?.name}&rdquo;?
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button onClick={handleConfirm} color='error' autoFocus>
					Delete
				</Button>
			</DialogActions>
		</Dialog>
	);
};

PromptDeleteDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	prompt: PropTypes.object,
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
};

export default PromptDeleteDialog;
